import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useMercuryContext } from "context";
import { Layout, Drawer, Button } from "antd";
import logo from "assets/icons/RWS_logo-white.svg";

import LeftMenu from "components/layout/LeftMenu";
import RightMenu from "components/layout/RightMenu";

import "./header.scss";

import ProgressLoader from "components/layout/ProgressLoader";
import { ROUTES } from "common/constants/routes";
import { useScrollMonitor } from "shared/components/Components";
import AppSwitcher from "./AppSwitcher";

const Header = ({ adminMenuData }: any) => {
  const location = useLocation();
  const { selectedApp, userDetails } = useMercuryContext();

  useEffect(() => {
    const header = document.querySelector(".main-header");
    if (header) {
      header.classList.remove("slimmer");
    }
    window.scrollTo(0, 0);
  }, [location]);

  const
      { Header } = Layout,
      { accessToken } = useMercuryContext(),
      [drawOpen, setDrawOpen] = useState(false),
      position = useScrollMonitor();

  let
      height = 64,
      className = "main-header"

  if ( position < 64 && position >= 40 ) {
    height = 64 - ( position -40 )
  }
  else if ( position < 64 ) {
    height = 64
  }
  else {
    height = 40;
  }

  if ( height <= 47 ) {
    className = "main-header slimmer";
  }

  function toggleDrawer() {
    setDrawOpen(!drawOpen);
  }

  const handleCopyToken = (e:any) => {
    // only on double click
    if (e.detail === 2) {
      navigator.clipboard.writeText(accessToken);
    }
  };

  const getDefaultPath = (selectedCA: string) => {
    const app = userDetails.customerApplicationDetails?.find((a: any) => a._id === selectedCA);

    switch (app?.name) {
      case "Google":
        return ROUTES.GOOGLE_MAIN;
      case "OLiVE":
        return ROUTES.OLIVE_MAIN;
      default:
        return ROUTES.MAIN;
    }

  }

  return (
    <Header id={"main-header"} className={className}>
      <nav className="menuBar">
        <div className="leftContainer">
          <div className="logoContainer">
            <Link to={getDefaultPath(selectedApp)}>
              <img src={logo} className="logo logo-lg" alt="logo" />
            </Link>
            <div className="product-name">
              <div className="product-app-container">
                <h1 onClick={handleCopyToken}>Mercury</h1>
                <AppSwitcher />     
              </div>
                   
            </div>
          </div>
        </div>
        <div className="menuCon">
          <div className="leftMenu">
            <LeftMenu {...{adminMenuData}} />
          </div>
          <div className="rightMenu">
              <div className="progressCon">
                  <ProgressLoader />
              </div>
            <RightMenu {...{ adminMenuData }} />
          </div>
          { !drawOpen && <Button className="barsMenu" type="primary" onClick={toggleDrawer}>
            <span className="barsBtn"/>
            <span className="barsBtn"/>
            <span className="barsBtn"/>
          </Button> }
          <Drawer
            title="Menu"
            placement="right"
            closable={true}
            onClose={toggleDrawer}
            open={drawOpen}
            width={350}
            className="header-drawer"
          >
            <LeftMenu mobile={true} {...{ adminMenuData }} />
            <RightMenu drawOpen {...{ adminMenuData }} />
          </Drawer>
        </div>
      </nav>
    </Header>
  );
}

export default Header;
